import { useState, useEffect } from 'react';
import { Modal, Stack, TextInput, Textarea, Button, Group } from '@mantine/core';
import { useFlowMutations } from '../hooks/useFlowMutations';
import { Flow } from '@/services/flows.api';

interface EditFlowModalProps {
  opened: boolean;
  onClose: () => void;
  flow: Flow | null;
}

export function EditFlowModal({ opened, onClose, flow }: EditFlowModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const { updateMutation } = useFlowMutations();

  useEffect(() => {
    if (flow) {
      setName(flow.name);
      setDescription(flow.description || '');
    }
  }, [flow]);

  const handleSubmit = async () => {
    if (!flow) return;

    try {
      await updateMutation.mutateAsync({ id: flow.id, data: { name, description } });
      onClose();
    } catch (error) {
      alert('Failed to update flow. Please try again.');
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Edit Flow">
      <Stack>
        <TextInput
          label="Flow Name"
          placeholder="My Flow"
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
        />
        <Textarea
          label="Description (optional)"
          placeholder="Describe what this flow does..."
          value={description}
          onChange={(e) => setDescription(e.currentTarget.value)}
          rows={3}
        />
        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose}>Cancel</Button>
          <Button onClick={handleSubmit} disabled={!name || updateMutation.isPending} loading={updateMutation.isPending} style={{ backgroundColor: '#415A91' }}>
            Save
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
